// extracted by mini-css-extract-plugin
export var sectionTitle = "tourGrid-module--sectionTitle--3UEF4";
export var slidebottom = "tourGrid-module--slidebottom--1YdLZ";
export var mymasonrygrid = "tourGrid-module--mymasonrygrid--xv68t";
export var mymasonrygridcolumn = "tourGrid-module--mymasonrygridcolumn--3RbC5";